import * as React from "react";
const SvgDiamond = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18.347 3.295A.75.75 0 0 0 17.725 3H6.271a.75.75 0 0 0-.62.3L2.165 7.78a.75.75 0 0 0-.015.922l8.012 11.345A2.234 2.234 0 0 0 12.06 21a2.234 2.234 0 0 0 1.78-.952l8.018-11.356a.76.76 0 0 0 .14-.368.75.75 0 0 0-.16-.54l-3.49-4.488ZM15.574 4.5 12 7.298 8.425 4.5h7.15ZM5.5 5.936V7.5H4.283L5.5 5.936ZM5.777 9l3.333 6.956L4.198 9h1.58Zm1.664 0h3.809v7.95L7.44 9Zm2.383-1.5H7V5.289l2.824 2.21ZM12.75 9h3.81l-3.81 7.95V9ZM17 7.5h-2.825L17 5.289v2.21Zm1.5 0V5.936L19.716 7.5h-1.215ZM18.224 9h1.58l-4.916 6.962L18.223 9Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDiamond;
